import { Runtime } from '@/core/enums/runtime.enum'

export const UNKNOWN_REPOSITORY = 'unknown-repository'
export const UNKNOWN_LIBRARY = 'unknown-library'

export const SOURCE_RUNTIME_TO_REPOSITORY: Record<Runtime, string> = {
  [Runtime.Nodejs]: 'npm',
  [Runtime.Netcore]: 'nuget',
  [Runtime.Jvm]: 'maven',
  [Runtime.Python]: 'pypi',
  [Runtime.Ruby]: 'rubygems',
  [Runtime.Php]: 'packagist',
}
